import { datePickerFieldStyle } from '@/components/ui/Form/DatePickerField/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * DatePickerMultiField のスタイル
 */
export const datePickerMultiFieldStyle = tv({
    slots: {
        base: [datePickerFieldStyle().base()],
    },
});
